import { Component } from "@angular/core";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";
import { isObservable, Observable } from "rxjs";

@Component({
    standalone: false,
    templateUrl: "./horizontalSelect.component.html",
})
export class FormlyHorizontalSelect extends FieldType<FieldTypeConfig> {
    editable: boolean = false;
    styleClass: string;

    ngOnInit() {
        this.field.props = Object.assign(
            { filter: true, editable: false },
            this.field.props
        );

        if (this.props) {
            this.editable = this.field.props.editable || false;
        }

        this.styleClass = "form-control p-0 hz-dropdown-min-height";
    }

    selectionChanged($event) {
        const option = (this.props.options as any).find(
            (s) => s.value === $event.value
        );
        if (this.props.change) this.props.change(this, option);
    }

    getOptions(options: any[] | Observable<any[]>): any[] | Observable<any[]> {
        if (!options) return [];
        else if (isObservable(options)) return options;
        else {
            if ((options || []).length > 0) {
                var existing = options.findIndex(
                    (option) => option.value == ""
                );

                //sort the options based on alphanumeric order
                options.sort((a, b) => a.value?.toString().localeCompare(b.value, 'en', { numeric: true }));

                if (existing === -1) {
                    options.splice(0, 0, { label: "&nbsp;", value: "" });
                }
            }

            return options;
        }
    }
}
